import React from 'react'
import { OrganizationRow } from './OrganizationRow'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Badge from '@material-ui/core/Badge'
import HomeIcon from '@material-ui/icons/Home'
import PropTypes from 'prop-types'

export class OrganizationGroup extends React.Component {
    state = {
        expanded: false
    }

    toggleExpanded = () => {
        this.setState(prevState => ({ expanded: !prevState.expanded }))
    }

    render() {
        const { ourId, items, classes, openId, onOpenDialog, onCloseDialog, onUpdate, onDelete } = this.props
        const { expanded } = this.state

        if (items.length === 1) {
            return (
                <OrganizationRow
                    item={items[0]}
                    classes={classes}
                    openId={openId}
                    onOpenDialog={onOpenDialog}
                    onCloseDialog={onCloseDialog}
                    onUpdate={onUpdate}
                    onDelete={onDelete}
                    nested={false}
                />
            )
        }

        return (
            <React.Fragment>
                <TableRow hover className={classes.groupRow} onClick={this.toggleExpanded} key={ourId}>
                    <TableCell>
                        <div className={classes.expandCell}>
                            <span style={{ marginRight: 8 }}>{ourId}</span>
                            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </div>
                    </TableCell>
                    <TableCell>{items[0].ourName}</TableCell>
                    <TableCell>
                        <Badge badgeContent={items.length} color="primary">
                            <HomeIcon />
                        </Badge>
                    </TableCell>
                    <TableCell colSpan={3} />
                </TableRow>
                {expanded &&
                    items.map(item => (
                        <OrganizationRow
                            key={item.remoteId}
                            item={item}
                            classes={classes}
                            openId={openId}
                            onOpenDialog={onOpenDialog}
                            onCloseDialog={onCloseDialog}
                            onUpdate={onUpdate}
                            onDelete={onDelete}
                            nested={true}
                        />
                    ))}
            </React.Fragment>
        )
    }
}

OrganizationGroup.propTypes = {
    ourId: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    openId: PropTypes.string,
    onOpenDialog: PropTypes.func.isRequired,
    onCloseDialog: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/OrganizationTab/OrganizationTable/OrganizationGroup.js